import { Component, OnInit } from '@angular/core';
import { ConfigService } from '../../config/config.service';
import { Router, ActivatedRoute, Params, Data } from '@angular/router';
import { RegistrationService } from './services/registration.service';
import { NotificationService } from "../../shared/services/notification.service";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { regExValidator } from 'src/app/shared/validators/regExValidator';
import * as Globalsmessages from '../../shared/globals.messages';
import * as Globals from '../../shared/globals';
import { Title } from '@angular/platform-browser';
import { repeatedCharactersValidator } from '../../shared/validators/repeatedCharactersValidator';
import { userregistration } from '../model_temp/userregistration.model';
import { cannotContainSpaceValidator } from 'src/app/shared/validators/cannotContainSpaceValidator';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'registration-cmp',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent implements OnInit {
  loading: boolean = false;
  display: boolean = false;
  applicationLogo: string = '';
  header1: string = '';
  baseUrl: string = '';
  userregistration: userregistration;
  displayInvalidLink: boolean = false;
  warningMessage: string = '';
  warningHeader: string = '';
  registerForm: UntypedFormGroup;
  enableregister: boolean = false;
  key: any;
  iv: any;
  applyEncription: boolean;

  constructor(
    private router: Router, private route: ActivatedRoute,
    private config: ConfigService,
    private notification: NotificationService,
    private registrationservice: RegistrationService,
    private fb: UntypedFormBuilder,
    private titleService: Title) {
    this.userregistration = new userregistration();
    route.params.subscribe(
      params => {
        this.userregistration.Id = params['Id'];
      }
    );
    this.header1 = config.getUiConfiguration('LogincomponentHeader');
    if (!this.header1) {
      config.load().then(() => {
        this.applicationLogo = config.result["ApplicationLogo"];
        this.applyEncription = config.get("applyEncription");
        this.key = CryptoJS.enc.Utf8.parse(Globals.EncryptionKeys.PasswordEncryptionKey);
        this.iv = CryptoJS.enc.Utf8.parse(Globals.EncryptionKeys.PasswordEncryptionIV);
      });
    }
  }

  ngOnInit(): void {
    this.titleService.setTitle("Viracor Fetch - Register");
    if (this.userregistration.Id == undefined || !this.isGuid(this.userregistration.Id)) {
      this.displayInvalidLink = true;
      this.warningHeader = "Invalid Link!";
      this.warningMessage = Globalsmessages.registerUserLinkInvalid[0];
    }
    this.buildForm();
    Object.keys(this.registerForm.controls).forEach(key => {
      this.registerForm.controls[key].setValidators(this.setValidators()[key][1]);
      this.registerForm.controls[key].updateValueAndValidity();
    });
  }

  setValidators() {
    var loginNameStrings = this.userregistration.UserName.split('@');
    var loginNameRegEx = new RegExp(loginNameStrings[0], 'i');
    const model = {
      UserName: ['UserName', [Validators.required]],
      password: ['password', [Validators.required, Validators.minLength(10), regExValidator(), repeatedCharactersValidator(), cannotContainSpaceValidator.cannotContainSpace]],
      confirmPassword: ['confirmPassword', [Validators.required, Validators.minLength(10), regExValidator(), repeatedCharactersValidator(), cannotContainSpaceValidator.cannotContainSpace]]
    };
    return model;
  }
  buildForm(): void {
    this.registerForm = this.fb.group({
      'UserName': [this.userregistration.UserName, [Validators.required]],
      'password': [this.userregistration.password, [Validators.required, Validators.minLength(10), regExValidator(), repeatedCharactersValidator(), cannotContainSpaceValidator.cannotContainSpace]],
      'confirmPassword': [this.userregistration.confirmPassword, [Validators.required, Validators.minLength(10), regExValidator(), repeatedCharactersValidator(), cannotContainSpaceValidator.cannotContainSpace]]
    });
    this.registerForm.valueChanges.subscribe(data => this.onValueChanged(data));
    this.onValueChanged();
  }

  onValueChanged(data?: any) {
    if (!this.registerForm) { return; }
    const form = this.registerForm;
    for (const field in this.formErrors) {
      this.formErrors[field] = '';
      const control = form.get(field);
      const messages = this.validationMessages[field];
      if ((field == "password" || field == "confirmPassword") && control && control.dirty)
        if (this.registerForm.controls["UserName"].value != null &&
          this.registerForm.controls["UserName"].value != undefined &&
          this.registerForm.controls["UserName"].value != "" &&
          this.registerForm.controls["UserName"].value.length > 0) {
          var loginNameStrings = this.registerForm.controls.UserName.value.split('@');
          var loginNameRegEx = new RegExp(loginNameStrings[0], 'i');
          if (loginNameRegEx.test(this.registerForm.controls[field].value)) {
            var validationMessage = messages["forbiddenName"];
            if (validationMessage != null && validationMessage !== "") {
              this.formErrors[field] += '- ' + validationMessage + '\n';
              this.enableregister = false;
            }
          }
          else {
            this.enableregister = true;
          }
        }
      if ((field == "password" || field == "confirmPassword") && control && control.dirty)
        if (this.registerForm.controls["password"].value != null &&
          this.registerForm.controls["password"].value != undefined &&
          this.registerForm.controls["password"].value != "" &&
          this.registerForm.controls["password"].value.length > 0) {
          if (this.registerForm.controls["password"].value != this.registerForm.controls["confirmPassword"].value) {
            var validationMessage = messages["mismatch"];
            if (validationMessage != null && validationMessage !== "") {
              this.formErrors["confirmPassword"] += '- ' + validationMessage + '\n';
              this.enableregister = false;
            }
          }
          else {
            this.enableregister = true;
          }
        }
      if (field == "UserName" && !control.valid && !control.dirty && this.registerForm.dirty) {
        this.enableregister = false;
        this.formErrors["UserName"] += '- ' + this.validationMessages.UserName.required + '\n';
      }
      if (control && control.dirty && (!control.valid || !this.enableregister)) {
        for (const key in control.errors) {
          var validationMessage = messages[key];
          if (validationMessage != null && validationMessage !== "") {
            this.formErrors[field] += '- ' + validationMessage + '\n';
          }
        }
      }
    }
  }
  formErrors = {
    'UserName': '',
    'password': '',
    'confirmPassword': ''
  };

  validationMessages = {
    'password': {
      'required': Globalsmessages.newPasswordRequired[0],
      'minlength': Globalsmessages.newPasswordMinLength[0],
      'forbiddenName': Globalsmessages.newPasswordForbiddenName[0],
      'regExValue': Globalsmessages.newPasswordNotAllowedCharacters[0],
      'repeatedCharacters': Globalsmessages.newPasswordRepeatedCharacters[0],
      'mismatch': Globalsmessages.mismatch[0],
      'cannotContainSpace': Globalsmessages.passwordcannotContainSpace[0],
    },
    'confirmPassword': {
      'required': Globalsmessages.confirmPasswordRequired[0],
      'minlength': Globalsmessages.confirmPasswordMinLength[0],
      'regExValue': Globalsmessages.confirmPasswordNotAllowedCharacters[0],
      'forbiddenName': Globalsmessages.confirmPasswordForbiddenName[0],
      'repeatedCharacters': Globalsmessages.confirmPasswordRepeatedCharacters[0],
      'mismatch': Globalsmessages.mismatch[0],
      'cannotContainSpace': Globalsmessages.confirmpasswordcannotContainSpace[0],
    },
    'UserName': {
      'required': 'Username is required.'
    }
  };

  registrationSubmit(): void {
    this.loading = true;
    if (this.userregistration.password === this.userregistration.confirmPassword) {
      var encryptednewpassword = new userregistration();
      encryptednewpassword = this.userregistration;
      if (this.applyEncription) {
        encryptednewpassword.password = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(encryptednewpassword.password), this.key, {
          keySize: 128 / 8,
          iv: this.iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        }).toString();
        encryptednewpassword.confirmPassword = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(encryptednewpassword.confirmPassword), this.key, {
          keySize: 128 / 8,
          iv: this.iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        }).toString();
      }
      this.registrationservice.registerUser(encryptednewpassword).subscribe(
        res => this.processSaveStatus(res), err => this.handleError(err));
    }
    else {
      this.loading = false;
      this.display = true;
    }
  }

  resetform() {
    this.userregistration = new userregistration();
  }

  processSaveStatus(response: any) {
    this.loading = false;
    if (response.isSuccessful) {
      if (response.warningMessages.length > 0) {
        this.notification.showWarning(response.warningMessages[0], "Warning!");
      }
      else {
        this.notification.showSuccess(response.informationMessage[0], "Success");
        this.router.navigate(['']);
      }
    }
    else {
      if (response.errorMessages != null) {
        this.notification.showError(response.errorMessages[0], 'Error!');
        this.loading = false;
      }
      else {
        this.notification.showError('An error occurred while registering the user. Please try again!', 'Error!');
        this.loading = false;
      }
    }
  }

  handleError(err: any) {
    this.notification.showError("An error occurred while registering the User. Please try again!", "Error!");
    this.loading = false;
  }

  isGuid(stringToTest) {
    if (stringToTest[0] === "{") {
      stringToTest = stringToTest.substring(1, stringToTest.length - 1);
    }
    var regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
    return regexGuid.test(stringToTest);
  }

  redirectToLogin() {
    this.displayInvalidLink = false;
    this.router.navigate(['']);
  }
}